import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { saveStateOrderDriverPickup, updateTrxRide } from "../../Store/Actions/booking";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import formatDateIdn from "../../Utils/formatDate";
import { getOrderRide } from "../../Store/Actions/user";
import { AppDispatch } from "../../Store/Reducers";
import { isEmpty } from "../../Utils/string";

const statusOptions = [
    { label: "Tunda", value: "Tunda" },
    { label: "Terima", value: "Terima" },
    { label: "Selesai", value: "Selesai" },
    { label: "Tolak", value: "Tolak" },
    { label: "Batal", value: "Batal" },
    { label: "Fiktif", value: "Fiktif" },
];

const OrderRideListMobile = () => {
    const dispatch: AppDispatch = useDispatch();
    const { dataOrderRide } = useSelector((state: any) => state.userReducer);
    const { dataTrackingReducer } = useSelector((state: any) => state.bookingReducer);

    const [orders, setOrders] = useState([]);
    const [page,] = useState(1);
    const [limit,] = useState(10);
    const [selectedStatus, setSelectedStatus] = useState(["Terima"]);
    const [invoiceNoRide, setInvoiceNoRide] = useState("");

    const { tokenPath, refreshToken, userId } = useParams();

    useEffect(() => {
        if (tokenPath) {
            const userData = {
                access_token: tokenPath,
                refresh_token: refreshToken,
                user: { id: userId },
            };
            dispatch(saveStateOrderDriverPickup(userData));
            sessionStorage.setItem("sb-wnpukijoybwfgrpearge-auth-token", JSON.stringify(userData));
        }
    }, [dispatch, tokenPath, refreshToken, userId]);

    useEffect(() => {
        const form = {
            id_trx: "",
            invoice_no_ride: invoiceNoRide,
            user_id_driver: dataTrackingReducer?.users_id || "",
            user_id_customer: "",
            status: selectedStatus.join(","),
            page,
            limit,
        };

        dispatch(getOrderRide(form));
    }, [dispatch, invoiceNoRide, selectedStatus, page, limit, dataTrackingReducer?.users_id]);

    useEffect(() => {
        if (dataOrderRide?.data) {
            setOrders(dataOrderRide.data);
        }
    }, [dataOrderRide]);

    const handleFinish = async (id: any) => {
        const res: any = await dispatch(updateTrxRide({ id, status: "Selesai" }));
        if (res?.data) {
            toast.success(res?.message || "Orderan selesai", { autoClose: 1000 });
            const form = {
                id_trx: "",
                invoice_no_ride: invoiceNoRide,
                user_id_driver: dataTrackingReducer?.users_id || "",
                user_id_customer: "",
                status: selectedStatus.join(","),
                page,
                limit,
            };
            await dispatch(getOrderRide(form));
        }
    };

    return (
        <div className="p-4">
            <div className="mb-4">
                <div className="w-full">
                    {/* Tags */}
                    <div className="flex flex-wrap gap-2 mb-2">
                        {selectedStatus.map((status) => (
                            <span
                                key={status}
                                className="flex items-center bg-blue-100 text-blue-700 text-sm px-2 py-1 rounded-full"
                            >
                                {status}
                                <button
                                    onClick={() =>
                                        setSelectedStatus(selectedStatus.filter((s) => s !== status))
                                    }
                                    className="ml-1 text-blue-500 hover:text-blue-700"
                                >
                                    &times;
                                </button>
                            </span>
                        ))}
                    </div>

                    {/* Dropdown */}
                    <select
                        className="w-full border rounded px-3 py-2 text-sm"
                        onChange={(e) => {
                            const selected = e.target.value;
                            if (!selectedStatus.includes(selected)) {
                                setSelectedStatus([...selectedStatus, selected]);
                            }
                        }}
                        value=""
                    >
                        <option value="" disabled>Pilih status...</option>
                        {statusOptions
                            .filter((opt) => !selectedStatus.includes(opt.value))
                            .map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                            ))}
                    </select>
                </div>

            </div>

            <input
                type="text"
                placeholder="No Invoice"
                className="w-full border rounded px-3 py-2 mb-2 text-sm"
                onChange={(e) => setInvoiceNoRide(e.target.value)}
            />

            <div className="overflow-x-auto">
                <table className="min-w-full table-auto border border-gray-200 text-sm">
                    <thead>
                        <tr className="bg-gray-100">
                            <th className="border px-4 py-2">No Invoice</th>
                            <th className="border px-4 py-2">Tanggal</th>
                            <th className="border px-4 py-2">Aksi</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isEmpty(orders) ? (
                            <tr>
                                <td colSpan={4} className="text-center py-4">
                                    Loading...
                                </td>
                            </tr>
                        ) : (
                            orders?.map((row: any, idx: number) => (
                                <tr key={row.id || idx}>
                                    <td className="border px-4 py-2">{row.invoice_no_ride}</td>
                                    <td className="border px-4 py-2">{formatDateIdn(row.created_at)}</td>
                                    <td className="border px-4 py-2 text-center">
                                        {row.status === "Terima" && (
                                            <button
                                                className="bg-green-500 hover:bg-green-600 text-white text-xs px-3 py-1 rounded"
                                                onClick={() => handleFinish(row.id)}
                                            >
                                                Selesai
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>

                {/* <div className="flex flex-wrap justify-center items-center gap-2 mt-4 text-sm">
                    <button
                        onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                        disabled={page === 1}
                        className={`px-3 py-1 rounded ${page === 1 ? "bg-gray-200 text-gray-500 cursor-not-allowed" : "bg-blue-500 text-white hover:bg-blue-600"}`}
                    >
                        Prev
                    </button>

                    {Array.from({ length: Math.ceil(dataOrderRide?.total / limit) }, (_, idx) => idx + 1).map((p) => (
                        <button
                            key={p}
                            onClick={() => setPage(p)}
                            className={`px-3 py-1 rounded ${p === page ? "bg-blue-600 text-white" : "bg-gray-200 hover:bg-gray-300"}`}
                        >
                            {p}
                        </button>
                    ))}

                    <button
                        onClick={() => setPage((prev) => prev + 1)}
                        disabled={page >= Math.ceil(dataOrderRide?.total / limit)}
                        className={`px-3 py-1 rounded ${page >= Math.ceil(dataOrderRide?.total / limit)
                            ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                            : "bg-blue-500 text-white hover:bg-blue-600"}`}
                    >
                        Next
                    </button>
                </div> */}


            </div>
        </div>
    );
};

export default OrderRideListMobile;
